import { render, staticRenderFns } from "./goodsDetails.vue?vue&type=template&id=c1ffa6f0&scoped=true"
import script from "./goodsDetails.vue?vue&type=script&lang=js"
export * from "./goodsDetails.vue?vue&type=script&lang=js"
import style0 from "./goodsDetails.vue?vue&type=style&index=0&id=c1ffa6f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ffa6f0",
  null
  
)

export default component.exports